import React from 'react';
import { UIGameLayout } from './UIGameLayout/UIGameLayout.tsx';
import { UIGameSpectatorsProvider } from './UIGameSpectators/UIGameSpectatorsContext.tsx';
import { GameStoreContext } from '../store/GameStoreContext.ts';
import 'simplebar-react/dist/simplebar.min.css';
import { UIGameTranslationProvider } from '../contexts/UIGameTranslationContext.tsx';
export default function UIGame({ options, gameStore }) {
    return /*#__PURE__*/ React.createElement(GameStoreContext.Provider, {
        value: gameStore
    }, /*#__PURE__*/ React.createElement(UIGameTranslationProvider, {
        translationKeyContext: gameStore.getState().gameMode.translationKeyContext
    }, /*#__PURE__*/ React.createElement(UIGameSpectatorsProvider, null, /*#__PURE__*/ React.createElement(UIGameLayout, {
        initialCanResign: options.initialCanResign,
        isChatEnabled: options.isChatEnabled
    }))));
}
